import { StateCreator } from 'zustand';
import { StoreSlices } from '.';

export interface GlobalProps {
  isPreview: boolean;
  shopConfiguration: any;
}
export interface GlobalSlice extends GlobalProps {}

export const createGlobalSlice =
  (
    initProps?: Partial<GlobalProps>,
  ): StateCreator<
    Partial<StoreSlices>,
    [['zustand/devtools', never], ['zustand/immer', never]],
    [],
    GlobalSlice
  > =>
  () => ({
    isPreview: initProps?.isPreview ?? false,
    shopConfiguration: initProps?.shopConfiguration,
  });
